// @@ AI-COMMENT: Shared field styling for the User Management dialogs.
// Deliberately not using forms.scss .form-field — its `input, select { height: 30px; border: 1px solid #858585 }`
// rule outranks Tailwind utilities, so the controls are styled here instead to keep full control.

export const FIELD_LABEL = 'block text-[11px] font-semibold text-[#43425D] mb-1.5';

export const FIELD_ERROR = 'text-[11px] text-red-600 mt-1';

const FIELD_BASE =
    'w-full text-xs text-[#3F3F3F] bg-white border rounded-md outline-none transition-colors ' +
    'placeholder:text-[#A3A6B4] focus:ring-2 disabled:bg-[#F2F2F5]';

const FIELD_TONE = (invalid?: boolean) =>
    invalid
        ? 'border-red-400 focus:border-red-500 focus:ring-red-100'
        : 'border-[#E0E0E6] hover:border-[#C9C9D2] focus:border-[#278BED] focus:ring-blue-100';

// @@ AI-COMMENT: Single-line controls (input / select) share one 36px height
export const fieldControl = (invalid?: boolean) => `${FIELD_BASE} ${FIELD_TONE(invalid)} h-9 px-2.5`;

// @@ AI-COMMENT: Multi-line control; height comes from the rows attribute
export const fieldTextarea = (invalid?: boolean) => `${FIELD_BASE} ${FIELD_TONE(invalid)} p-2.5 resize-none leading-relaxed`;

// @@ AI-COMMENT: Marks a required field next to its label
export const REQUIRED_MARK = 'text-red-500';
